import { render, staticRenderFns } from "./SignIndexV2.vue?vue&type=template&id=3cc39546&scoped=true&"
import script from "./SignIndexV2.vue?vue&type=script&lang=ts&"
export * from "./SignIndexV2.vue?vue&type=script&lang=ts&"
import style0 from "./SignIndexV2.vue?vue&type=style&index=0&id=3cc39546&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cc39546",
  null
  
)

export default component.exports